import React, { useState, useEffect } from "react";
import NftAvatar from "./NftAvatar";

const Download = ({ locale: initLocale }) => {
  const [locale, setLocale] = useState(initLocale || "en");
  const isZh = locale && locale.startsWith("zh");

  const contactName = "05df…a3b1";
  const messages = isZh
    ? [
        { from: "them", text: "欸！你有用過 Vapor 嗎？" },
        { from: "me", text: "剛裝好，不用手機號碼欸！" },
        { from: "them", text: "對啊，只要帳戶 ID，完全匿名。" },
        { from: "me", text: "而且全程端對端加密？" },
        { from: "them", text: "沒錯！還有洋蔥路由，誰都追蹤不到。" },
      ]
    : [
        { from: "them", text: "Hey! Have you tried Vapor?" },
        { from: "me", text: "Just installed it, no phone number needed!" },
        { from: "them", text: "Right, just an Account ID. Fully anonymous." },
        { from: "me", text: "And it's end-to-end encrypted?" },
        { from: "them", text: "Yes! Onion routing too, no one can track it." },
      ];

  const [visibleCount, setVisibleCount] = useState(0);

  useEffect(() => {
    setVisibleCount(0);
  }, [isZh]);

  useEffect(() => {
    if (visibleCount < messages.length) {
      const timer = setTimeout(() => setVisibleCount((c) => c + 1), 1000);
      return () => clearTimeout(timer);
    } else {
      const timer = setTimeout(() => setVisibleCount(0), 3500);
      return () => clearTimeout(timer);
    }
  }, [visibleCount, messages.length]);

  return (
    <div className="dl-page">
      {/* 語言切換 */}
      <div className="dl-lang">
        <button className={`dl-lang-btn ${!isZh ? "active" : ""}`} onClick={() => setLocale("en")}>EN</button>
        <span className="dl-lang-sep">/</span>
        <button className={`dl-lang-btn ${isZh ? "active" : ""}`} onClick={() => setLocale("zh-TW")}>中</button>
      </div>

      <div className="dl-inner">
        {/* 左側：手機（與首頁統一風格） */}
        <div className="dl-left">
          <div className="dl-phone">
            {/* hover 加密盾牌 */}
            <div className="dl-shield">
              <svg className="dl-shield-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                <path d="M9 12l2 2 4-4" />
              </svg>
              <span className="dl-shield-text">{isZh ? "訊息已加密保護" : "Messages Protected"}</span>
            </div>

            {/* 動態島 */}
            <div className="dl-notch" />

            {/* 頂部導航 */}
            <div className="dl-topbar">
              <span className="dl-back">
                <svg width="8" height="14" viewBox="0 0 8 14" fill="none" stroke="#00d46a" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M7 1L1 7l6 6"/>
                </svg>
              </span>
              <div className="dl-contact">
                <NftAvatar id={0} size={36} />
                <div className="dl-contact-info">
                  <span className="dl-contact-name">{contactName}</span>
                  <span className="dl-contact-status">
                    <span className="dl-status-dot" />
                    {isZh ? "已加密" : "Encrypted"}
                  </span>
                </div>
              </div>
              <span className="dl-call">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#00d46a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/>
                </svg>
              </span>
            </div>

            {/* 聊天內容 */}
            <div className="dl-messages">
              {visibleCount < messages.length && visibleCount > 0 && (
                <div className="dl-msg-row dl-msg-them">
                  <div className="dl-typing">
                    <span /><span /><span />
                  </div>
                </div>
              )}

              {messages.slice(0, visibleCount).map((msg, i) => (
                <div
                  className={`dl-msg-row ${msg.from === "me" ? "dl-msg-me" : "dl-msg-them"} dl-msg-animated`}
                  key={`${visibleCount}-${i}`}
                >
                  <div className="dl-bubble">{msg.text}</div>
                </div>
              ))}
            </div>

            {/* 底部輸入框 */}
            <div className="dl-inputbar">
              <div className="dl-input-plus">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#999" strokeWidth="2" strokeLinecap="round">
                  <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
                </svg>
              </div>
              <div className="dl-input-field">Message...</div>
              <div className="dl-input-send">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="#00d46a">
                  <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/>
                </svg>
              </div>
            </div>

            {/* 底部橫條 */}
            <div className="dl-home-bar" />
          </div>
        </div>

        {/* 右側：文字 + 按鈕 */}
        <div className="dl-right">
          <div className="dl-logo">
            <img src="/vapor-icon.svg" alt="Vapor" className="dl-logo-icon" />
            <span className="dl-logo-text">VAPOR</span>
          </div>

          <h1 className="dl-title">
            {isZh ? "暢所欲言\n了無痕跡" : "Speak Freely\nLeave No Trace"}
          </h1>
          <p className="dl-subtitle">
            {isZh
              ? "透過去中心化加密技術實現的私密通訊"
              : "Private messaging through decentralized encryption"}
          </p>

          <div className="dl-buttons">
            <a href="/artifact/vapor-12.9.2-release.apk" download className="dl-btn-main">
              <svg className="dl-btn-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="7 10 12 15 17 10" /><line x1="12" y1="15" x2="12" y2="3" />
              </svg>
              <div className="dl-btn-text">
                <span className="dl-btn-label">{isZh ? "直接下載" : "Direct Download"}</span>
                <span className="dl-btn-sub">Android APK 12.9.2</span>
              </div>
            </a>

            <a
              href="https://play.google.com/store/apps/details?id=network.loki.messenger.cn&hl=zh"
              target="_blank"
              rel="noopener noreferrer"
              className="dl-btn-main dl-btn-gp"
            >
              <svg className="dl-btn-icon" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M3.61 1.814L13.793 12 3.61 22.186a.996.996 0 0 1-.61-.92V2.734a1 1 0 0 1 .61-.92zm.96-.494l11.18 6.454-2.73 2.732L4.57 1.32zm0 21.36l8.46-9.186 2.73 2.732L4.57 22.68zm12.64-7.296L20.78 12l-3.57-3.384L14.52 12l2.69 2.384z" />
              </svg>
              <div className="dl-btn-text">
                <span className="dl-btn-label">Google Play</span>
                <span className="dl-btn-sub">{isZh ? "前往商店" : "Get it on"}</span>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Download;
